import { Spin } from "antd";

function CustomSpinLoading() {
  return (
    <div
      className="absolute inset-y-2/4 inset-x-2/4"
    >
      <Spin size="large" className="mt-10" />
    </div>
  );
}
export default CustomSpinLoading;
